import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown, Icon, Menu } from 'antd';

const ContextMenu = ({
  children, data, menuItems, onContextClick
}) => {
  const MenuItems = () => (
    <Menu className="bhp-context-menu" selectable>
      {
        menuItems.map(item => (
          <Menu.Item data={data} key={item.task} onClick={onContextClick} disabled={item.disabled()}>
            <span className="bhp-context-menu-item" title={item.tooltip && item.disabled() ? item.tooltip : undefined}>
              {item.icon && <Icon type={item.icon} />}
              {item.title}
            </span>
          </Menu.Item>
        ))
      }
    </Menu>
  );

  return (
    <Dropdown overlay={MenuItems} trigger={['contextMenu']}>
      {children}
    </Dropdown>
  );
};

ContextMenu.propTypes = {
  data: PropTypes.object,
  onContextClick: PropTypes.func,
  children: PropTypes.object,
  menuItems: PropTypes.array
};

ContextMenu.defaultProps = {
  data: {
    title: 'Menu'
  },
  onContextClick() {
  },
  children: {},
  menuItems: []
};

export default ContextMenu;
